import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=f6ee069e&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ee069e"]])

export default __exports__